// // UploadArea.jsx
// import {
//   useCallback,
//   useRef,
//   useState,
//   forwardRef,
//   useImperativeHandle,
// } from "react";

// const UploadArea = forwardRef(function UploadArea(
//   { onFilesAdded, message, disabled = false },
//   ref
// ) {
//   const [hover, setHover] = useState(false);
//   const [toggle, setToggle] = useState(false);
//   const [inputKey, setInputKey] = useState(0); // hard reset
//   const inputRef = useRef(null);

//   useImperativeHandle(ref, () => ({
//     reset() {
//       if (inputRef.current) inputRef.current.value = "";
//       setInputKey((k) => k + 1); // remount input (lets user re-pick the same file)
//     },
//   }));

//   const handleFiles = useCallback(
//     (files) => {
//       const arr = Array.from(files || []);
//       const valid = arr.filter(
//         (f) =>
//           f.type === "application/pdf" || f.name.toLowerCase().endsWith(".pdf")
//       );
//       if (valid.length) onFilesAdded(valid);
//     },
//     [onFilesAdded]
//   );

//   const onDrop = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     if (disabled) return;
//     setHover(false);
//     handleFiles(e.dataTransfer?.files);
//   };

//   const handleToggle = () => {
//     const newValue = !toggle;
//     setToggle(newValue);
//     message?.(newValue);
//   };

//   return (
//     <div className="bg-white rounded-xl shadow-md p-6 mb-6 space-y-4">
//       <div className="flex items-center justify-between gap-4">
//         <h2 className="text-2xl font-semibold text-gray-800 leading-none">
//           {toggle ? "Upload MR Documents" : "Upload Medical Papers"}
//         </h2>

//         <button
//           type="button"
//           onClick={handleToggle}
//           className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 focus:outline-none ${
//             toggle ? "bg-indigo-600" : "bg-gray-300"
//           }`}
//           aria-pressed={toggle}
//           disabled={disabled}
//         >
//           <span
//             className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
//               toggle ? "translate-x-6" : "translate-x-1"
//             }`}
//           />
//         </button>
//       </div>

//       <div
//         className={`file-upload rounded-lg p-8 text-center cursor-pointer transition-all duration-300 ${
//           hover ? "active" : ""
//         } ${disabled ? "opacity-60 pointer-events-none" : ""}`}
//         onDragEnter={() => !disabled && setHover(true)}
//         onDragOver={(e) => {
//           e.preventDefault();
//           !disabled && setHover(true);
//         }}
//         onDragLeave={() => setHover(false)}
//         onDrop={onDrop}
//         onClick={() => !disabled && inputRef.current?.click()}
//       >
//         <div className="flex flex-col items-center justify-center">
//           {/* icon */}
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-12 w-12 text-indigo-500 mb-3"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
//             />
//           </svg>

//           {/* text — fixed invalid nested <p> */}
//           <p className="text-gray-600 mb-2">
//             {toggle
//               ? "Upload MR documents to generate structured medical detailing."
//               : "Upload a research paper to get summaries, audio narration, and interactive Q&A."}
//           </p>

//           <button
//             className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-6 rounded-lg transition duration-300"
//             disabled={disabled}
//           >
//             Browse Files
//           </button>

//           <input
//             key={inputKey} // 👈 force remount after reset()
//             ref={inputRef}
//             type="file"
//             accept=".pdf"
//             multiple
//             className="hidden"
//             onChange={(e) => {
//               if (e.target.files?.length) handleFiles(e.target.files);
//             }}
//             disabled={disabled}
//           />

//           <p className="text-xs text-gray-400 mt-3">
//             You can select multiple PDFs
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// });

// export default UploadArea;


import {
  useCallback,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";

const UploadArea = forwardRef(function UploadArea(
  { onFilesAdded, disabled = false },
  ref
) {
  const [hover, setHover] = useState(false);
  const [inputKey, setInputKey] = useState(0); // hard reset
  const inputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    reset() {
      if (inputRef.current) inputRef.current.value = "";
      setInputKey((k) => k + 1); // remount input (lets user re-pick the same file)
    },
  }));

  const handleFiles = useCallback(
    (files) => {
      const arr = Array.from(files || []);
      const valid = arr.filter(
        (f) =>
          f.type === "application/pdf" || f.name.toLowerCase().endsWith(".pdf")
      );
      if (valid.length) onFilesAdded(valid);
    },
    [onFilesAdded]
  );

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    setHover(false);
    handleFiles(e.dataTransfer?.files);
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6 mb-6 space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between gap-4">
        <h2 className="text-2xl font-semibold text-gray-800 leading-none">
          Upload Medical Papers
        </h2>
      </div>

      {/* Upload Section */}
      <div
        className={`file-upload rounded-lg p-8 text-center cursor-pointer transition-all duration-300 ${
          hover ? "active" : ""
        } ${disabled ? "opacity-60 pointer-events-none" : ""}`}
        onDragEnter={() => !disabled && setHover(true)}
        onDragOver={(e) => {
          e.preventDefault();
          !disabled && setHover(true);
        }}
        onDragLeave={() => setHover(false)}
        onDrop={onDrop}
        onClick={() => !disabled && inputRef.current?.click()}
      >
        <div className="flex flex-col items-center justify-center">
          {/* Upload Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12 text-indigo-500 mb-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
            />
          </svg>

          {/* Upload Info */}
          <p className="text-gray-600 mb-2">
            Upload a research paper to get summaries, audio narration, and interactive Q&A.
          </p>

          <button
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-6 rounded-lg transition duration-300"
            disabled={disabled}
          >
            Browse Files
          </button>

          <input
            key={inputKey}
            ref={inputRef}
            type="file"
            accept=".pdf"
            multiple
            className="hidden"
            onChange={(e) => {
              if (e.target.files?.length) handleFiles(e.target.files);
            }}
            disabled={disabled}
          />

          <p className="text-xs text-gray-400 mt-3">
            You can select multiple PDFs
          </p>
        </div>
      </div>
    </div>
  );
});

export default UploadArea;
